export const BASE_URL = 'https://www.russrodgersbassguitar.com';

export interface SitemapPage {
  path: string;
  priority: number;
}

export const SITEMAP_PAGES: SitemapPage[] = [
  { path: '/', priority: 1.0 },
  { path: '/bass-lessons/zoom-setup', priority: 0.7 },
  { path: '/x-ploration-jazz', priority: 0.9 },
  { path: '/bass-lessons/testimonials', priority: 0.8 },
  { path: '/bass-lessons/what-i-teach', priority: 0.8 },
  { path: '/bass-lessons/play-along-tracks', priority: 0.7 },

  { path: '/about/bio', priority: 0.8 },
  { path: '/about/resume', priority: 0.8 },
  { path: '/about/credits', priority: 0.8 },
  { path: '/about/discography', priority: 0.7 },
  { path: '/about/performance', priority: 0.7 },
  { path: '/about/gear', priority: 0.6 },

  { path: '/blog', priority: 0.8 },
];
